import React from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'

@inject('store') @observer
class InternalRedirect extends React.Component {
  componentDidUpdate() {
    if (this.props.store.redirect.pathname) {
      this.props.store.clearRedirect()
    }
  }
  render() {
    const {redirect} = this.props.store
    if (redirect.pathname) {
      return <Redirect push to={redirect}/>
    }
    return null
  }
}

export default InternalRedirect
